import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import goodtolog from "../../Assests/Goodtogo.svg";
import set from "../../Assests/Set.svg";
import tick from "../../Assests/Tickregister.svg";
import { Pricing } from "../Pricing";
import HowtouseWrap from "./style";

export const HowtoUse = ({ setScrollItem }) => {
  const [fadeIn, setFadeIn] = useState(false);
  const howToUseRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          console.log("entry---", entry);
          if (entry.isIntersecting) {
            setFadeIn(true);
            setScrollItem("howtouse");
          } else {
            // setScrollItem("")
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    if (howToUseRef.current) {
      observer.observe(howToUseRef.current);
    }

    return () => {
      if (howToUseRef.current) {
        observer.unobserve(howToUseRef.current);
      }
    };
  }, []);

  return (
    <>
      <HowtouseWrap>
        <Container
          fluid
          style={{ background: "#F4F4F4" }}
          className="contain-margin"
        >
          <section id="howtouse" ref={howToUseRef}>
            <div className="steps-contain">
              {/* <Row>
                <Col></Col>
              </Row> */}
              <Fade top when={fadeIn} duration={1000} distance="50px">
                <Row className="my-4">
                  <section class="success-section">
                    <h2 class="section-title">Driving Success At Scale</h2>

                    <div class="row success-row">
                      <div class="col success-card">
                        <h3>100k</h3>
                        <p>Active Users</p>
                      </div>

                      <div class="col success-card">
                        <h3>1,000+</h3>
                        <p>Vehicles & Drivers Onboarded</p>
                      </div>

                      <div class="col success-card">
                        <h3>400k</h3>
                        <p>Consignments Delivered</p>
                      </div>

                      <div class="col success-card">
                        <h3>20,000+</h3>
                        <p>Tons of CO2 calculated</p>
                      </div>
                    </div>
                  </section>
                </Row>
              </Fade>
            </div>
          </section>
        </Container>
      </HowtouseWrap>
      {/* <Fade bottom when={fadeIn} duration={1000}>
        <Pricing setScrollItem={setScrollItem}/>
      </Fade> */}
      <Container>{/* <Tymeplusmobile /> */}</Container>
    </>
  );
};
